import Cookies from "js-cookie";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import BreadCrumbMenu from "src/components/breadCrumbMenu/BreadCrumbMenu";
import SideBar from "src/components/SideBar/SideBar";
import { setToken } from "src/redux/slices/bMCProfileSlice";
import { AUTH_TOKEN, devLocationOrigin } from "src/resources/constant";
import { RoutePaths } from "src/resources/enum";

const BMCPageContainer = ({className, children }: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const breadCrumbsPaths = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const isLoggedIn = useSelector((state: any) => state.bMCProfile.token);

  useEffect(() => {
    const token = Cookies.get(AUTH_TOKEN);
    if (!isLoggedIn && !token && window.location.origin !== devLocationOrigin) {
      navigate(RoutePaths.Home);
    } else if (token) {
      dispatch(setToken(token));
    }
  }, [isLoggedIn]);

  return (
    <>
      <SideBar />
      <div className={`main-content-inner pt-4 ${className||''}`}>
        {breadCrumbsPaths.length > 0 && (
          <div className="px-3">
            <BreadCrumbMenu />
          </div>
        )}
        {children}
      </div>
    </>
  );
};

export default BMCPageContainer;
